import { getIcons } from '@app/services/api.service';
import { Action, ThunkAction } from '@reduxjs/toolkit';
import _ from 'underscore';
import { AppState } from '../index';
import { fetchIconsSuccess } from './actions';

/**
 * Перейти в категорию (загрузив её данные и данные под-элементов)
 *
 * @param elementId Идентификатор категории
 */
export const fetchIcons =
  (): ThunkAction<void, AppState, null, Action<string>> =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async (dispatch, getState) => {
    const iconsResponse: any = await getIcons();
    const icons = _.indexBy(iconsResponse, 'id');
    dispatch(fetchIconsSuccess(icons));
  };
